import React from 'react'; 
import './comp.css'; 
import { Card, Row, Col } from 'antd';

function Experience(){
    return (
        <div  className="background">
            <Row justify="center" className="card" xl={20}>
                <Col xs={20} sm={18} md={12} lg={8} xl={6} >
                    <Card  cover={<img alt="example" src="https://1000logos.net/wp-content/uploads/2016/10/Apple-Logo.png" />} style={{ width: 300 }}>
                        <h1>Apple</h1>
                        <h3>Tools & Automation Engineer</h3>
                        <h4>July 2022 - Present</h4>
                        <p>Working in Swift & Python to develop automation for software update testing</p>
                        <p>Worked extensively with iOS, macOS, and visionOS to develop UI automation</p>
                    </Card>
                    <br></br>
                </Col>
                <Col xs={20} sm={18} md={12} lg={8} xl={6} >
                    <Card cover={<img alt="example" src="https://1000logos.net/wp-content/uploads/2016/10/American-Express-logo.png" />} style={{ width: 300 }}>
                        <h2>American Express</h2>
                        <h3>iOS Software Engineer Intern</h3>
                        <h4>Summer 2021</h4>
                        <p>Worked on small UI facing projects for a Summer Internship</p>
                        <p>Devloped on the official AMEX iOS app in Swift</p>
                    </Card>
                </Col>
            </Row>
            <Row justify="center" className="card" >
                <Col xs={20} sm={18} md={12} lg={8} xl={6} >
                    <Card  cover={<img alt="example" src="https://i.imgur.com/nj6iw5Q.png" />} style={{ width: 300 }}>
                        <h1>Middlebury College</h1>
                        <h3>Computer Science</h3>
                        <h4>Expected Grad: May 2022</h4>
                        <p>Computer Science Department, Tutor</p>
                        <p>Under Represented in STEM (URSTEM) Club, Treasurer</p>
                        <p>The Middlebury Video Game Club, President</p>
                    </Card>
                </Col>
                <br></br>
                <Col xs={20} sm={18} md={12} lg={8} xl={6} >
                    <Card cover={<img alt="example" src="https://i.imgur.com/IkVff7Q.png" />} style={{ width: 300 }}>
                        <h2>MiddCORE: Innovation Program</h2>
                        <h3>Student Consultant</h3>
                        <h4>Winter 2020</h4>
                        <p>Built professional skills in mentor guided workshops</p>
                        <p>Worked in small teams to solve problems for emerging companies</p>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default Experience; 